class IconTextGrid {
  constructor(root) {
    this.root = root;
    this.scroller = root.querySelector('[data-ce-itg-scroller]');
    this.items = Array.from(root.querySelectorAll('[data-ce-itg-item]'));
    this.dots = Array.from(root.querySelectorAll('[data-ce-itg-dot]'));

    if (!this.scroller || this.items.length < 2) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        const item = this.items[index];
        if (item) {
          item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });

    this.scroller.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(() => this.syncDots());
      },
      { passive: true }
    );

    this.syncDots();
  }

  syncDots() {
    if (!this.dots.length) return;

    const scrollerRect = this.scroller.getBoundingClientRect();
    const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    this.items.forEach((item, index) => {
      const itemRect = item.getBoundingClientRect();
      const itemCenter = itemRect.left + itemRect.width / 2;
      const distance = Math.abs(itemCenter - scrollerCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    this.dots.forEach((dot, index) => {
      dot.setAttribute('aria-current', index === closestIndex ? 'true' : 'false');
    });
  }
}

function initIconTextGrids() {
  document.querySelectorAll('[data-icon-text-grid]').forEach((root) => {
    if (root.dataset.ceItgInitialized === 'true') return;
    root.dataset.ceItgInitialized = 'true';
    new IconTextGrid(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIconTextGrids);
} else {
  initIconTextGrids();
}

document.addEventListener('shopify:section:load', initIconTextGrids);
